let organisations_ajax = ( function ( $ ) {

	let get_select2_options = function ( params ) {
		return {
			q : params.term || '',
			page : params.page || 1,
			amount: 20,
			nonce : ScriptData.crate_practices_get_select2_options_nonce,
			action : 'crate_practices_get_select2_options'
		};
	};

	let get_singular = function( org_id, callback ) {
		$.post( ScriptData.ajaxurl, {
			'id' : org_id,
			'nonce' : ScriptData.crate_practices_get_singular_nonce,
			'action' : 'crate_practices_get_singular'
		}, callback )
	}

	return {
		get_select2_options: get_select2_options,
		get_singular: get_singular
	}

} )( jQuery );

module.exports = organisations_ajax;